<template>
	<div :class="['form-modal bg-white', { 'delete': $route.query.action === 'delete' }]">
		<div class="form-modal__header">
			<h2>{{ $t(`form.${$route.query.action}.${$route.query.model}.title`) }}</h2>
			<SiteLink class="form-modal__button-close" icon="close" :to="{ ...this.$route, query: {...( this.$route.query.date ? { date: this.$route.query.date } : {} ), ...( this.$route.query.filter ? { filter: this.$route.query.filter } : {} )} }" />
		</div>
		<div class="form-modal__content">
			<p v-if="$route.query.action !== 'delete'" class="note --required">{{ $t('form.messages.required') }}</p>
			<component :is="is" ref="form" @update:valid="(valid) => form.valid = valid"
				@update:actions="({ enabled }) => form.can_add_actions = enabled" />
		</div>
		<div class="form-modal__footer">
			<button v-if="secondaryLabel" class="btn --white --border" @click.prevent="handleSecondaryAction"
				:disabled="form.submitted">
				{{ secondaryLabel }}
			</button>

			<button v-if="$route.query.model === $query.MODEL.ACTION" class="btn --white --border"
				@click.prevent="$refs.form?.add()" :disabled="!form.can_add_actions">
				{{ $t(`form.create.action.button`) }}
				<Icon id="plus" />
			</button>

			<button :class="['btn', '--blue', '--submit-button', {'--submitting': form.submitting }]" @click.prevent="handleSubmit()"
				:disabled="(form.submitted || !form.valid) && ($route.query.action !== $query.ACTION.DELETE || ($route.query.action === $query.ACTION.DELETE && $route.query.admin === 'true'))">
				{{ submitLabel }}
				<span class="--loader"></span>
			</button>
		</div>
	</div>
</template>

<script>
import {
	AddEditActuality,
	AddEditCategory,
	AddEditDocument,
	AddEditEmployee,
	AddEditEvent,
	AddEditNotice,
	AddEditSubCategory,
	DeleteConfirmation,
	EditActions,
	EditAlert
} from '@/components/form/blocks'
import { Icon } from '@/components/global'
import { SiteLink } from '@/components/small'

export default {
	name: 'Form',
	components: {
		Icon,
		SiteLink
	},
	data() {
		return {
			form: {
				can_add_actions: false,
				submitted: false,
				submitting: false,
				valid: false
			},
		}
	},
	computed: {
		is() {
			if (this.$query.MODEL.ACTION === this.$route.query.model) {
				return EditActions
			}

			if (this.$query.ACTION.DELETE === this.$route.query.action) {
				return DeleteConfirmation
			}

			if ([this.$query.ACTION.CREATE, this.$query.ACTION.EDIT].includes(this.$route.query.action)) {
				switch (this.$route.query.model) {
					case this.$query.MODEL.ACTUALITY:
						return AddEditActuality
					case this.$query.MODEL.ALERT:
						return EditAlert
					case this.$query.MODEL.CATEGORY:
						return AddEditCategory
					case this.$query.MODEL.DOCUMENT:
						return AddEditDocument
					case this.$query.MODEL.EVENT:
						return AddEditEvent
					case this.$query.MODEL.EMPLOYEE:
						return AddEditEmployee
					case this.$query.MODEL.NOTICE:
						return AddEditNotice
					case this.$query.MODEL.SUB_CATEGORY:
						return AddEditSubCategory
				}
			}

			return null
		},
		secondaryLabel() {
			if (this.$route.query.action === this.$query.ACTION.DELETE) {
				return this.$t('form.delete.noDelete')
			}

			if ([this.$query.MODEL.ALERT, this.$query.MODEL.EMPLOYEE].includes(this.$route.query.model)) {
				return this.$t(`form.${this.$route.query.action}.${this.$route.query.model}.delete`)
			}

			return null
		},
		submitLabel() {
			switch (this.$route.query.action) {
				case this.$query.ACTION.DELETE:
					return this.$t(`form.delete.${this.$route.query.model}.button`)
				case this.$query.ACTION.CREATE:
				case this.$query.ACTION.EDIT:
				default:
					return this.$t('form.label.save')
			}
		}
	},
	methods: {
		async handleSecondaryAction() {
			this.form.submitted = true

			if (this.$route.query.model === this.$query.MODEL.ALERT) {
				await this.$alert.update(this.$alert.data.id, { text: '' })
			}

			if (this.$route.query.model === this.$query.MODEL.EMPLOYEE) {
				await this.$employee.destroy(this.$refs.form.form.fields.employee_id?.value)
				this.$popup.report(`${this.$t('popup.theEmployee')} ${this.$t('popup.deletedElement')}`, false)
			}

			this.$router.push({ name: this.$route.name, query: {...( this.$route.query.date ? { date: this.$route.query.date } : {} ), ...( this.$route.query.filter ? { filter: this.$route.query.filter } : {} )} })

			this.form.submitted = false
		},
		async handleSubmit() {
			this.form.submitting = true
			await this.$refs.form.submit()

			this.$router.push({ name: this.$route.name, query: {...( this.$route.query.date ? { date: this.$route.query.date } : {} ), ...( this.$route.query.filter ? { filter: this.$route.query.filter } : {} )} })
		}
	}
}
</script>